import PostFeed from './PostFeed'

export default PostFeed
